import { render, staticRenderFns } from "./Firmware.vue?vue&type=template&id=10bbea49&scoped=true"
import script from "./Firmware.vue?vue&type=script&lang=js"
export * from "./Firmware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bbea49",
  null
  
)

export default component.exports